import React, { useEffect, useState } from 'react';
import { localsMessages } from '../../utility/getTemplateData';
import { Tooltip } from '@paypalcorp/pp-react';
import AppDispatcher from '../../dispatcher/AppDispatcher';
import * as AppConstants from '../../utility/constants';
import AppStore from '../../stores/AppStore';
import PropTypes from 'prop-types';

const messages = localsMessages('common/ppcc');

function PPCC({ isHeader }) {
  const [showTooltip, setShowTooltip] = useState(AppStore.getPPCCStatus());
  let dispatcherMessages;
  const registerAppDispatcherMessages = () => {
    dispatcherMessages = AppDispatcher.register((payload) => {
      if (
        payload.action &&
        payload.action.actionType === AppConstants.UPDATE_PPCC_STATUS
      ) {
        setShowTooltip(payload.action.item);
      }
    });
  };

  useEffect(() => {
    registerAppDispatcherMessages();
    return function cleanup() {
      AppDispatcher.unregister(dispatcherMessages);
    };
  }, []);

  if (!showTooltip) {
    return null;
  }
  return (
    <Tooltip
      className={isHeader ? 'ppcc_tooltip_within_header' : 'ppcc_tooltip'}
      description={messages.ppcc.tooltip}
      verifiedIcon
    />
  );
}

PPCC.propTypes = {
  isHeader: PropTypes.bool,
};

export default PPCC;
